import React, { memo } from 'react';
const CHECKOUT_URL = 'https://checkout.tiendadigitalonline.com/cart/47950473298161:1';
export function FinalCTA() {
  return <section className="w-full bg-black py-16 md:py-20 px-4" data-id="element-185">
      <div className="max-w-3xl mx-auto text-center" data-id="element-186">
        <h2 className="font-heading font-bold text-3xl md:text-5xl text-white leading-tight mb-6" data-id="element-187">
          🔮 El Tarot puede ser una herramienta real en tu vida
        </h2>

        <p className="font-body text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-188">
          No necesitás memorizar todo.
        </p>
        <p className="font-body text-lg md:text-xl text-white font-semibold mb-10" data-id="element-189">
          Necesitás entender, practicar y conectar.
        </p>

        <a href={CHECKOUT_URL} className="inline-block bg-gradient-to-r from-gold-500 to-gold-600 text-black font-heading font-bold text-xl md:text-2xl px-10 py-5 rounded-xl animate-pulse-glow hover:from-gold-400 hover:to-gold-500 transition-all duration-300 uppercase tracking-wide shadow-2xl mb-8" data-id="element-190">
          👉 Accedé ahora a Tarot y Autoconocimiento
        </a>

        <p className="font-body text-lg md:text-xl text-gray-400" data-id="element-191">
          Porque no se trata solo de leer cartas…
        </p>
        <p className="font-heading font-bold text-2xl md:text-3xl text-gold-500 mt-2" data-id="element-192">
          sino de entenderte a vos. ✨
        </p>
      </div>
    </section>;
}